import { Component } from "react";

import "./style.scss";

class Tooltip extends Component {

    state={
        show:false
    }

    toggleVisibility=()=>{
        this.setState({show:!this.state.show});
    }

    mouseUpHandler=(e)=>{
        if(e.target!==this.hit) this.setState({show:false});
    }

    componentDidMount(){
        window.addEventListener("mouseup", this.mouseUpHandler);
    }

    componentWillUnmount(){
        window.removeEventListener("mouseup", this.mouseUpHandler);
    }

    render() {
        return (
            <div className={`tooltip ${this.state.show ? "show" : ""}`}><span ref={el => (this.hit = el)} onClick={this.toggleVisibility}>?</span><div className="tooltip-text">{this.props.text}</div></div>
        )
    }
}

export default Tooltip;